export default "__VITE_ASSET__ae4aea46__"